import { Link } from "react-router-dom";
import { Cross, ArrowLeft, ArrowRight, XCircle } from "lucide-react";

export default function PaymentCanceled() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-white rounded-2xl border border-gray-200 shadow-xl p-8 text-center" data-testid="payment-canceled">
        <Link to="/" className="inline-flex items-center gap-2 mb-6">
          <div className="h-10 w-10 rounded-lg bg-emerald-600 text-white flex items-center justify-center">
            <Cross className="h-5 w-5" strokeWidth={2.5} />
          </div>
          <span className="font-head text-lg font-extrabold">FarmaPresenze</span>
        </Link>
        <XCircle className="h-14 w-14 text-gray-400 mx-auto" />
        <h1 className="font-head text-2xl font-extrabold mt-4">Pagamento annullato</h1>
        <p className="text-sm text-gray-600 mt-3">Non è stato effettuato alcun addebito. Puoi tornare ai piani quando vuoi.</p>
        <div className="mt-6 flex flex-col gap-2">
          <Link to="/prezzi" data-testid="payment-canceled-back" className="h-12 px-6 rounded-lg bg-emerald-600 text-white text-sm font-semibold flex items-center justify-center gap-2 hover:bg-emerald-700">
            <ArrowLeft className="h-4 w-4" /> Torna ai piani
          </Link>
          <Link to="/" className="h-12 px-6 rounded-lg border border-gray-200 text-gray-700 text-sm font-semibold flex items-center justify-center gap-2 hover:bg-gray-50">
            Vai alla home <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
